import { render, staticRenderFns } from "./VasUnsubModal.vue?vue&type=template&id=d62f0dc2"
import script from "./VasUnsubModal.vue?vue&type=script&lang=js"
export * from "./VasUnsubModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports